import React, { useState, useEffect } from 'react'
import { Box, Paper, Loader, Text, Grid, Group, ThemeIcon } from '@mantine/core'
import { getDataStatsUserSurvey } from '../../../services/dashboard'
import { PieChart } from '@mantine/charts'
import { IconPointFilled } from '@tabler/icons-react'

const DashboardStatsSurvey = () => {
  const [loadingStatistic, setLoadingStatistic] = useState(true)
  const [statsUserSurvey, setStatsUserSurvey] = useState([])

  const getRandomColor = () => {
    const letter = '0123456789ABCDEF'
    let color = '#'
    for (let i = 0; i < 6; i++) {
      color += letter[Math.floor(Math.random() * 16)]
    }
    return color
  }

  const handleGetStatsUserSurvey = async () => {
    setLoadingStatistic(true)
    try {
      const response = await getDataStatsUserSurvey()
      if (response?.data) {
        const responseStats = response.data.managementStats.user.survey || []
        const remap = [
          {
            name: 'Search Engine (Google,etc.)',
            value: responseStats.searchEngine ? responseStats.searchEngine : 0,
            ccolor: getRandomColor()
          },
          {
            name: 'Referral',
            value: responseStats.referral ? responseStats.referral : 0,
            color: getRandomColor()
          },
          {
            name: 'Email Newsletter',
            value: responseStats.emailNewsletter ? responseStats.emailNewsletter : 0,
            color: getRandomColor()
          },
          {
            name: 'WhatsApp or Broadcast',
            value: responseStats.whatsappOrBroadcast ? responseStats.whatsappOrBroadcast : 0,
            color: getRandomColor()
          },
          {
            name: 'Telegram',
            value: responseStats.telegram ? responseStats.telegram : 0,
            color: getRandomColor()
          },
          {
            name: 'Facebook',
            value: responseStats.facebook ? responseStats.facebook : 0,
            color: getRandomColor()
          },
          {
            name: 'Instagram',
            value: responseStats.instagram ? responseStats.instagram : 0,
            color: getRandomColor()
          },
          {
            name: 'LinkedId',
            value: responseStats.linkedIn ? responseStats.linkedIn : 0,
            color: getRandomColor()
          },
          {
            name: 'Youtube',
            value: responseStats.youtube ? responseStats.youtube : 0,
            color: getRandomColor()
          },
        ]
        setStatsUserSurvey(remap)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingStatistic(false)
    }
  }

  useEffect(() => {
    handleGetStatsUserSurvey()
    // eslint-disable-next-line
  }, [])

  const loadingDataStats = () => {
    return (
      <Box ta='center' my={165}>
        <Loader size='sm' />
        <Text c='gray.6' fz={14}>Loading Data</Text>
      </Box>
    )
  }

  const loadLayoutStats = () => {
    const mappingDataSurvey = (data) => {
      if (data.length > 0) {
        const remap = data.map((val, index) => {
          return (
            <Group gap={2}>
              <ThemeIcon variant="white" size='lg' color={val.color}>
                <IconPointFilled style={{ width: '70%', height: '70%' }} />
              </ThemeIcon>
              <Text fz={12} fw='500'>{val.name}</Text>
            </Group>
          )
        })
        return remap
      }
    }

    return (
      <Box>
        <Grid align='flex-start'>
          <Grid.Col span={{ base: 12, md: 5, lg: 5 }}>
            <Box>
              {mappingDataSurvey(statsUserSurvey)}
            </Box>
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 7, lg: 7 }}>
            <PieChart
              size={260}
              data={statsUserSurvey}
              labelPosition='outside'
              labelsType='percent'
              withLabels
              withTooltip tooltipDataSource="segment"
            />
          </Grid.Col>
        </Grid>
      </Box>
    )
  }


  return (
    <Paper shadow="sm" p='md' withBorder radius='md'>
      <Text fz='md' fw='bold' mb='md'>How did You Hear About Us Survey</Text>
      <Box my={20}>
        {loadingStatistic ? loadingDataStats() : loadLayoutStats()}
      </Box>
    </Paper>
  )
}

export default DashboardStatsSurvey